// extracted by mini-css-extract-plugin
module.exports = {"premium-title":"designEvent_premium-title__3OxR0","locked-toggle":"designEvent_locked-toggle__298Os"};